import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import GalleryView from '../views/GalleryView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/galerija',
    name: 'galerija',
    component: GalleryView
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router